import { combineReducers } from 'redux';
import quiz from './quiz';
import persistedAt from './persistedAt';

export const quizAssessment = combineReducers({
    quiz,
    persistedAt
});
